"use strict";

exports.__esModule = true;
exports.TitleField = TitleField;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TitleField(props) {
  var setProp = props.setProp,
    value = props.value;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableColumnFields.title.label", "Column Title"),
    helperText: translate("DataTableColumnFields.title.helperText", "Column title.")
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    value: value,
    onChange: function onChange(e) {
      return setProp(e.target.value);
    }
  }));
}